import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {StateCountry, County} from 'src/app/shared/common-components/common-structure';
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Injectable({
  providedIn: 'root'
})
export class MasterdataAdminService extends DataService {

  private baseURI = this.apiUri + '/masterdataadmin/';
  private baseURIsros = this.apiUri + '/ratetypessro/';
  private controlKeysURI = this.apiUri + '/ratefileopen/';
  private frtServiceMasterURI = this.apiUri + '/frtservicesmaster/';
  private carrierURI = this.apiUri + '/carrier/';
  private tspURI = this.apiUri + '/agencytsp/';
  private observable$: any;
  private _logger: LoggerService;

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  saveorUpdateStateCountry(stateCountry: any): Observable<any> {
    this.setUri(this.baseURI + 'updatestatecountry');
    return this.update(stateCountry);
  }

  saveorUpdateStateCountryByZone(stateCountry: any): Observable<any> {
    this.setUri(this.baseURI + 'updatestatecountrybyzone');
    return this.update(stateCountry);
  }

  saveorUpdateStateCountryByCountry(stateCountry: any): Observable<any> {
    this.setUri(this.baseURI + 'updatestatecountrybycountry');
    return this.update(stateCountry);
  }

  saveorUpdateStateCountryByServiceArea(stateCountry: any): Observable<any> {
    this.setUri(this.baseURI + 'updatestatecountrybyservicearea');
    return this.update(stateCountry);
  }

  getStateCountryByStateCountryCode(stateCountryCode: string, stateCountryType: string): Observable<StateCountry[]> {
    this.setUri(this.baseURI + stateCountryCode + '/statecountrycode/' + stateCountryType + '/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getCountyByCountyNameAndStateCode(countyName: string, stateCode: string): Observable<County[]> {
    this.setUri(this.baseURI + countyName + '/countyname/' + stateCode + '/statecode');
    return this.get().pipe(catchError(this.handleError));
  }

  getStateCountryById(stateCountryId: number): Observable<StateCountry[]> {
    this.setUri(this.baseURI + stateCountryId + '/statecountryid');
    return this.get().pipe(catchError(this.handleError));
  }

  getHhgIccyById(iccId: number): Observable<any> {
    this.setUri(this.baseURI + iccId + '/iccid');
    return this.get().pipe(catchError(this.handleError));
  }

  getStateCountryByCode(stateCountryCode: string): Observable<any> {
    this.setUri(this.baseURI + stateCountryCode + '/statecountrycode');
    return this.get().pipe(catchError(this.handleError));
  }

  getHhgIccyByCode(iccCode: string): Observable<any> {
    this.setUri(this.baseURI + iccCode + '/icccode');
    return this.get().pipe(catchError(this.handleError));
  }

  saveorUpdateHhgIcc(hhgIcc: any): Observable<any> {
    this.setUri(this.baseURI + 'saveorupdatehhgicc');
    return this.update(hhgIcc);

  }

  saveorUpdateCounty(county: any): Observable<any> {
    this.setUri(this.baseURI + 'updatecounty');
    return this.update(county);

  }

  deleteCounty(county: any): Observable<any> {
    this.setUri(this.baseURI + 'deletecounty');
    return this.update(county);
  }

  deleteStateCountry(stateCountry: any): Observable<any> {
    this.setUri(this.baseURI + 'deletestatecountry');
    return this.update(stateCountry);
  }

  deleteStateCountryByCountry(stateCountry: any): Observable<any> {
    this.setUri(this.baseURI + 'deletestatecountrybycountry');
    return this.update(stateCountry);
  }

  deleteStateCountryByServiceArea(stateCountry: any): Observable<any> {
    this.setUri(this.baseURI + 'deletestatecountrybyservicearea');
    return this.update(stateCountry);
  }

  /* Function to get the Control Keys  by Control_Type='FRT Rate Filling" */
  getControlKeysByControlType(controlType: string): Observable<any> {
    this.setUri(this.apiUri + '/ratefileopen/' + controlType + '/controltype');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
     Function to get the sro id  by service level "LTL" or "TL"
    */
  getSros(rateTypeId: number): Observable<any> {
    this.setUri(this.baseURIsros + rateTypeId + '/rateTypeId');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
    Function to get the Control Keys record  by Control_Type='FRT Rate Filling" and effective and expiry date
   */
  getControlKeysByControlTypeAndEffectiveAndExpiry(controlType: string, effectiveDate: any, expiryDate: any): Observable<any> {
    this.setUri(this.controlKeysURI + controlType + '/controltype' + effectiveDate + '/effectivedate' + expiryDate + '/expirydate');
    return this.get().pipe(catchError(this.handleError));
  }

  getFrtServicesByServiceLevelAndSroMasterId(serviceLevel: string, sroMasterId: number): Observable<any> {
    this.setUri(this.baseURI + serviceLevel + '/servicelevel/' + sroMasterId + '/sromasterid');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
   Function to get the Control Keys  by Control_Id
  */
  getControlKeysByControlId(controlId: number): Observable<any> {
    this.setUri(this.apiUri + '/ratefileopen/' + controlId + '/controlid');
    return this.get().pipe(catchError(this.handleError));
  }


  saveorUpdateFreightServicesMaster(freightServicesMaster: any): Observable<any> {
    this.setUri(this.baseURI + 'saveorupdatefrtservicesmaster');
    return this.update(freightServicesMaster);

  }

  /* Function to get the list of Freight services master by Control Id and Service Level */
  getFrtServicesMasterByControlIdAndServiceLevel(controlId: number, serviceLevel: string): Observable<any> {
    this.setUri(this.frtServiceMasterURI + controlId + '/controlid/' + serviceLevel + '/servicelevel');
    return this.get().pipe(catchError(this.handleError));
  }

  getFrtServiceMasterBySroMasterId(sroMasterId: number): Observable<any> {
    this.setUri(this.frtServiceMasterURI + sroMasterId + '/sroMasterId');
    console.log(this.getUri);
    return this.get().pipe(catchError(this.handleError));
  }

  /* Function to get the list of control types(distinct) */
  getControlTypes(): Observable<any> {
    this.setUri(this.baseURI + '/controltypes');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
     Function to get the list of carrier by carrier type="RFSP"
    */
  getCarrierRfspsByCarrierTypeRfsp(): Observable<any> {
    this.setUri(this.carrierURI + 'carrierrfsps');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
     Function to get the list of carrier by carrier type!=="RFSP"
     and business type === 'HHG' OR 'HHG & FRT'
    */
  getCarrierByNotRfspAndBusinessType(): Observable<any> {
    this.setUri(this.carrierURI + 'carriersnotrfsp');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
     Function to get the list of carrierRfsps for the selected Carrier RFSPS
    */
  getCarrierRfspsByCarrierIdRfsp(carrierIdRfsp: number): Observable<any> {
    this.setUri(this.baseURI + carrierIdRfsp + '/carrieridrfsp');
    return this.get().pipe(catchError(this.handleError));
  }

  getAllRfspCarriers(): Observable<any> {
    this.setUri(this.baseURI + '/allrfspcarriers');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
     Function to get the Carrier for the selected Scac(tsp id)
    */
  getCarrierByCarrierIdTsp(carrierIdTsp: number): Observable<any> {
    this.setUri(this.baseURI + carrierIdTsp + '/carrieridtsp');
    return this.get().pipe(catchError(this.handleError));
  }

  /* Function to get the list with all shipment types for a carrier  */
  getCarrierRfspsByCarrierIdTsp(carrierIdTsp: number): Observable<any> {
    this.setUri(this.baseURI + carrierIdTsp + '/carrierwithallshipmenttypes');
    return this.get().pipe(catchError(this.handleError));
  }

  saveOrUpdateCarrierRfsps(carrierRfsps: any): Observable<any> {
    this.setUri(this.baseURI + 'saveorupdatecarrierrfsps');
    return this.update(carrierRfsps);

  }

  deleteCarrierRfsps(carrierRfsps: any): Observable<any> {
    this.setUri(this.baseURI + 'deletecarrierrfsps');
    return this.update(carrierRfsps);
  }

  saveOrUpdateControlKeys(controlKeys: any): Observable<any> {
    this.setUri(this.baseURI + 'saveorupdatecontrolkeys');
    return this.update(controlKeys);
  }

  saveFrtDieselPrice(frtDieselPrice: any): Observable<any> {
    this.setUri(this.baseURI + 'savefrtdieselprice');
    return this.update(frtDieselPrice);
  }

  getDieselPriceHistory(year: any): Observable<any> {
    this.setUri(this.baseURI + year + '/dieselpricebyyear');
    return this.get().pipe(catchError(this.handleError));
  }

  getZones(agencyMasterCode: any): Observable<any> {
    this.setUri(this.baseURI + agencyMasterCode + '/getfrtrateszone');
    return this.get().pipe(catchError(this.handleError));
  }

  getAllZones(): Observable<any> {
    this.setUri(this.baseURI + '/getallfrtrateszone');
    return this.get().pipe(catchError(this.handleError));
  }

  saveFrtRatesZone(frtRatesZone: any): Observable<any> {
    this.setUri(this.baseURI + 'savefrtrateszone');
    return this.update(frtRatesZone);
  }

  getAgencyMasterByAgencyCodeAndBureauCode(agencyCode: string, bureauCode: string): Observable<any> {
    this.setUri(this.baseURI + agencyCode + '/agencycode/' + bureauCode + '/bureaucode');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
     Function to get the list of carrier by carrier status = 'Active' and bussiness type = 'HHG' or 'HHG & FRT'
    */
  getActiveCarriersByHHGOrHHGFRT(): Observable<any> {
    this.setUri(this.baseURI + 'csiactivecarriers');
    return this.get().pipe(catchError(this.handleError));
  }

  getHhgCsiByControlId(csiRatePeriod: any): Observable<any> {
    this.setUri(this.baseURI + csiRatePeriod + '/controlid');
    return this.get().pipe(catchError(this.handleError));
  }

  saveorUpdateHhgCsiRecord(hhgCsi: any): Observable<any> {
    this.setUri(this.baseURI + 'saveupdatehhgcsi');
    return this.update(hhgCsi);
  }

  deleteHhgCsiRecord(hhgCsi: any): Observable<any> {
    this.setUri(this.baseURI + 'deletehhgcsi');
    return this.update(hhgCsi);
  }

  getCarrierByScac(scac: string): Observable<any> {
    this.setUri(this.carrierURI + scac + '/scacname');
    return this.get().pipe(catchError(this.handleError));
  }

  deleteControlKeysRecord(controlKeys: any): Observable<any> {
    this.setUri(this.baseURI + 'deletecontrolkeys');
    return this.update(controlKeys);
  }

  getAgencyTspCoreNotifications(): Observable<any> {
    this.setUri(this.tspURI + 'getAll');
    return this.get().pipe(catchError(this.handleError));
  }

  saveNewAgencyTspCoreNotifications(payload: any): Observable<any> {
    const url = this.tspURI + 'save'
    return this.http.post(url, payload);
  }

  updateAgencyTspCoreNotifications(payload: any): Observable<any> {
    const url = this.tspURI + 'update'
    return this.http.post(url, payload);
  }

  deleteAgencyTspCoreNotifications(payload: any): Observable<any> {
    const url = this.tspURI + 'delete'
    return this.http.post(url, payload);
  }

  /**
   * @description formats the value into comma seperator number (in thousands place) and adds $ sign to it.
   */
  formatNumber(params) {
    const number = params.value;
    if (AppConstants.isNotNullCondition(params.value)) {
      const parts = params.value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    } else {
      return '';
    }
  }

}
